import * as _ from "lodash";
import * as angular from "angular";

import { CModelRepo, Locality } from "../cmodel.repo";
import { CModelUtilities } from "../../common/cmodel.utilities";
import { CModelItem } from "../cmodelitem";
import { EditSecurityDialogController } from "./editSecurity.Dialog";
import { isNullOrUndefined } from "util";
import { AssetClassNames } from "../../common/enums/AssetClassType";
import { Geography } from "../models/geography";
import { Sector } from "../models/sector";
import {
  NamedItem,
  SecurityDetails,
} from "../../simulations/models/securityDetails";

class CModelSecurityManagementController implements angular.IOnInit {
  public equityList: SecurityDetails[];
  public archivedEquityList: SecurityDetails[];
  public fixedIncomeList: SecurityDetails[];
  public archivedFixedIncomeList: SecurityDetails[];
  public preciousMetalList: SecurityDetails[];
  public archivedMetalList: SecurityDetails[];
  public alternativeInvestmentList: SecurityDetails[];
  public archivedAlternativeInvestmentList: SecurityDetails[];
  public fixedIncomeTypeList: NamedItem[];

  public geographies: Geography[];
  public sectors: Sector[];
  public assetClasses: any;

  public collapseEquities: boolean;
  public collapseFixedIncomes: boolean;
  public collapsePreciousMetals: boolean;
  public collapseAlternativeInvestments: boolean;

  public loading: boolean;

  /** @ngInject */
  constructor(
    private cModelRepo: CModelRepo,
    private $mdDialog: angular.material.IDialogService,
    private $scope: angular.IScope,
    private $rootScope: angular.IRootScopeService,
    private notifyjs: any
  ) {}

  $onInit() {
    this.updateSecurityLists();
    this.updateFixedIncomeTypeList();
    this.updateGeographyList();
    this.updateSectorList();
    this.updateAssetClassList();
  }

  getLocality(id: number) {
    return Locality[id];
  }

  private sortSecurities(
    security1: SecurityDetails,
    security2: SecurityDetails
  ) {
    // put the nulls for sector and geography at the end and then reverse the list so that they appear at the top
    if (
      isNullOrUndefined(security1.sector) ||
      isNullOrUndefined(security1.geography)
    ) {
      return -1; //puts it in front of the list for 'a' being compared
    } else if (
      isNullOrUndefined(security2.sector) ||
      isNullOrUndefined(security2.geography)
    ) {
      return 1; //puts it in front of the list for 'b' being compared
    }

    return security1.name > security2.name ? 1 : -1;
  }

  updateSecurityLists() {
    this.loading = true;

    this.cModelRepo
      .getSecurityItemsList(null, null, false)
      .then((securities) => {
        this.equityList = [];
        this.fixedIncomeList = [];
        this.preciousMetalList = [];
        this.alternativeInvestmentList = [];

        securities.forEach((s) => {
          if (s.assetClass.name == AssetClassNames.EQUITY) {
            this.equityList.push(s);
          } else if (s.assetClass.name == AssetClassNames.FIXED_INCOME) {
            this.fixedIncomeList.push(s);
          } else if (s.assetClass.name == AssetClassNames.PRECIOUS_METALS) {
            this.preciousMetalList.push(s);
          } else if (s.assetClass.name == AssetClassNames.ALTERNATIVE_INV) {
            this.alternativeInvestmentList.push(s);
          }
        });

        this.equityList.sort(this.sortSecurities);
        this.fixedIncomeList.sort(this.sortSecurities);
        this.preciousMetalList.sort(this.sortSecurities);
        this.alternativeInvestmentList.sort(this.sortSecurities);

        this.archivedFixedIncomeList = this.fixedIncomeList.filter(
          (item) => item.active == false
        );
        this.fixedIncomeList = this.fixedIncomeList.filter(
          (item) => item.active == true
        );

        this.archivedEquityList = this.equityList.filter(
          (item) => item.active == false
        );
        this.equityList = this.equityList.filter((item) => item.active == true);
        this.archivedMetalList = this.preciousMetalList.filter(
          (item) => item.active == false
        );
        this.preciousMetalList = this.preciousMetalList.filter(
          (item) => item.active == true
        );

        this.archivedAlternativeInvestmentList =
          this.alternativeInvestmentList.filter((item) => item.active == false);
        this.alternativeInvestmentList = this.alternativeInvestmentList.filter(
          (item) => item.active == true
        );
      })
      .catch((err) => {
        // TODO: Look at logging to bugsnag
      })
      .finally(() => (this.loading = false));
  }

  updateGeographyList() {
    this.cModelRepo
      .getGeographiesList()
      .then((geographies) => (this.geographies = geographies));
  }

  updateSectorList() {
    this.cModelRepo
      .getSectorsList()
      .then((sectors) => (this.sectors = sectors));
  }

  updateFixedIncomeTypeList() {
    this.cModelRepo
      .getFixedIncomeTypes()
      .then(
        (fixedIncomeTypeList) =>
          (this.fixedIncomeTypeList = fixedIncomeTypeList)
      );
  }

  updateAssetClassList() {
    this.cModelRepo
      .getAssetClassList()
      .then((val) => (this.assetClasses = val.data));
  }

  showNewSecurityDialog(assetClass) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.geographies = this.geographies;
    tempScope.sectors = this.sectors;
    tempScope.assetClass = assetClass;
    tempScope.fixedIncomeTypes = this.fixedIncomeTypeList;

    this.$mdDialog
      .show({
        template:
          '<create-security-dialog geographies="geographies" sectors="sectors" asset-class="assetClass" fixed-income-types="fixedIncomeTypes"></create-security-dialog>',
        scope: tempScope,
        clickOutsideToClose: true,
        fullscreen: true, // Only for -xs, -sm breakpoints.
      })
      .then((newSecurity) => {
        switch (assetClass) {
          case AssetClassNames.EQUITY:
            this.equityList = [newSecurity, ...this.equityList];
            break;
          case AssetClassNames.PRECIOUS_METALS:
            this.preciousMetalList = [newSecurity, ...this.preciousMetalList];
            break;
          case AssetClassNames.ALTERNATIVE_INV:
            this.alternativeInvestmentList = [
              newSecurity,
              ...this.alternativeInvestmentList,
            ];
            break;
          case AssetClassNames.FIXED_INCOME:
            this.fixedIncomeList = [newSecurity, ...this.fixedIncomeList];
            break;
          default:
            this.notifyjs("Invalid Asset Class specified");
            break;
        }
      });
  }

  editSecurity(security: SecurityDetails) {
    const tempScope = this.$rootScope.$new(true) as any;
    tempScope.security = angular.copy(security);
    tempScope.geographies = this.geographies;
    tempScope.sectors = this.sectors;
    tempScope.assetClasses = this.assetClasses;
    tempScope.fixedIncomeTypes = this.fixedIncomeTypeList;

    this.$mdDialog
      .show({
        controller: EditSecurityDialogController,
        template:
          '<edit-security-dialog security="security" geographies="geographies" sectors="sectors" asset-classes="assetClasses" fixed-income-types="fixedIncomeTypes"></edit-security-dialog>',
        scope: tempScope,
        clickOutsideToClose: true,
        fullscreen: true, // Only for -xs, -sm breakpoints.
      })
      .then((val) => this.updateSecurityLists());
  }

  deleteSecurity(security: SecurityDetails) {
    this.$mdDialog
      .show(
        this.$mdDialog
          .confirm()
          .textContent(
            `Are you sure you would like to delete ${security.description} (${security.isin})?`
          )
          .title("Confirmation")
          .ok("Yes, delete security")
          .cancel("No")
          .ariaLabel(
            `Confirmation of deletion for security ${security.description}`
          )
      )
      .then(() => this.cModelRepo.deleteSecurity(security.id))
      .then(() => this.updateSecurityLists())
      .catch((err) => console.log(err));
  }
}

export const cModelSecurityManagement: angular.IComponentOptions = {
  template: require("../cmodel.securitymanagement/cmodel.securitymanagement.html"),
  controller: CModelSecurityManagementController,
};



// WEBPACK FOOTER //
// ./src/app/cmodel/cmodel.securitymanagement/cmodel.securitymanagement.ts